import React,{useEffect,useState} from 'react'
import { useTranslation } from 'react-i18next';
import {
    Button,
    Col,
    Divider,
    Image,
    Row,
    Typography,
    notification,
    Space,
    Form,
    Input, Upload, Spin, Select, Skeleton, InputNumber, Switch,
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useHistory, useParams } from 'react-router-dom';
import arrowLeft from '../../../src/img/arrow-left.png';
import addCat from '../../../src/img/add-category.png';
import stars from '../../../src/img/stars.png';
import openBook from '../../../src/img/open-book.png';
import imgIcon from '../../../src/img/image-icon.png';
import video from '../../../src/img/video.png';
import stepCircle from '../../../src/img/step-circle.png';
import { getImageUrl, UploadImage } from 'shared/services/Utility';
import API_SERVICE from 'shared/services/api-service';
import Parameters from 'shared/parameters';
import { fillEn } from 'client/src/methods/forms';
import {
    UploadOutlined,
    ArrowLeftOutlined,
} from '@ant-design/icons';
import FrontendSidebar from 'views/FrontendSidebar/FrontendSidebar';
interface Props{
    nextStep:any,
    prevStep:any,
    values:any,
    draftCourseId:any,
    draftCatVal:any,
    draftLevelVal:any,
    idCourse:any
}
interface hideHeader {
    hideHeader?: boolean;
  }
  const { Option } = Select;
function CourseDetails(props:Props,hideHeader:hideHeader) {
    const { nextStep, prevStep, values,draftCourseId,draftCatVal,draftLevelVal, idCourse } = props
    console.log('draftCatVal details page',draftCatVal)
    const { t } = useTranslation();
    const history: any = useHistory();
    const RouteParams: any = useParams();
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);
    const [draftSaving, setDraftSaving] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [instructors, setInstructors] = useState([] as any[]);
    const [categories, setCategories] = useState([] as any[]);
    const [levels, setLevels] = useState([] as any[]);
    const [item, setItem] = useState(null as any);
    const [finalValue,setFinalValue] = useState(null as any);
    const [plan, setPlan] = useState(null as any);
    const [image, setImage] = useState({ image: null, imageId: null } as any);
    const [uploading, setUploading] = useState(false);
    const [selectedLang, setSelectedLang] = useState('en' as any);
    const [lang, setLang] = useState('' as any);
    const refreshItem = async () => {
        try {
            setFetching(true);
            const {
                data: { data },
            } = await API_SERVICE.fetchCourseByIdAdmin(RouteParams['id']);
            setItem({
                ...data,
                instructor_id: data.user_id,
            });
            setImage({ image: getImageUrl(data.thumbnail), imageId: data.thumbnail_id });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    const refreshMetaData = async () => {
        try {
            if(Parameters.Mode !== 'CLIENT'){
            const {
                data: { data: { items: i } },
                } = await API_SERVICE.fetchUsers({ per_page: 1000 });
                setInstructors(i);
              const {
                data: { data: { items: c } },
              } = await API_SERVICE.fetchCategoriesAdmin({ per_page: 1000 });
              setCategories(c);
              const {
                data: { data: { items: l } },
              } = await API_SERVICE.fetchLevelsAdmin({ per_page: 1000 });
              setLevels(l);
            }else{
              const {
                data: { data: { items: c } },
              } = await API_SERVICE.fetchCategories({ per_page: 1000 });
              setCategories(c);
              const {
                data: { data: { items: l } },
              } = await API_SERVICE.fetchLevels({ per_page: 1000 });
              setLevels(l);
            }

        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        }
    };
    const uploadImage = async (file: any) => {
        setUploading(true);
        setImage({ image: null, imageId: null });
        const { image, imageId, error } = await UploadImage(file);
        if (error) {
            notification.error({ message: error });
        }
        setImage({ image, imageId });
        setUploading(false);
    };
    useEffect(() => {
        if (RouteParams['id']) {
            refreshItem();
        } else {
            setFetching(false);
        }
        refreshMetaData();
        let localLang = localStorage.getItem("language")
        if(localLang != undefined && localLang != null && localLang != ''){
            setSelectedLang(localLang)
        }
        setLang(localStorage.getItem('language'));
    }, []);

    const saveDraftData = () => {
        setDraftSaving(true);
        let form_vals = form.getFieldsValue();
        // let localData = JSON.parse(localStorage.getItem("auth-token") || "")
        // console.log('localData',localData)
        // return
        form_vals['category_id'] = draftCatVal;
        form_vals['level_id'] = draftLevelVal;
        console.log('draft saved value',form_vals)

        if(Parameters.Mode !== 'CLIENT'){
            API_SERVICE.createDraftCourseAdmin(form_vals).then((d) => {
                setDraftSaving(false);
                history.goBack();
            }).catch((e) => {
                notification.error({ message: API_SERVICE.handleErrors(e) });
                setDraftSaving(false);
            });
        }else {
            API_SERVICE.createDraftCourseInstructor(form_vals).then((d) => {
                setSaving(false);
                history.goBack();
            }).catch((e) => {
                notification.error({ message: API_SERVICE.handleErrors(e) });
                setSaving(false);
            });
        }
    }
if (fetching) {
    return <Skeleton active={true} />;
}
        return (
            <>
                <div className={hideHeader.hideHeader ? '' : ''}>
                    <div className='d-md-flex'>
                        <FrontendSidebar menuSelect={2} />
                        
                        <div className={Parameters.Mode === 'CLIENT' ? 'profile-tab-content-div mb-3': 'mb-3'} style={{width: '100%'}}>
                            {
                            !hideHeader.hideHeader && <>
                                
                                <div className="container-fluid">
                                    <div className='row'>
                                        {/* <div className='col-sm-12 mt-3'> */}
                                        <div className={lang == 'ar' ? 'text-right mt-3' : 'col-sm-12 mt-3'}>
                                            <h3><span className='back-bg mr-4 cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span> {RouteParams['mode'] === 'create' ? t('course.create') : ''}</h3>    
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                        <div className="container-fluid">
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='bg-white p-3 br-5px'>
                                        <div className="row">
                                            <div className="col-md-12 pt-3 pb-3">
                                                <div className="steps">
                                                    <ul id="progressbar" className="list-style-none w-100 d-flex">
                                                    <li className="w-100 steps-li">
                                                        <div className="progress">
                                                            <div className="progress-bar w-100"></div>
                                                        </div>
                                                        <div className="d-flex align-items-center mt-2">
                                                            <div className={lang == 'ar' ? 'text-right' : 'mr-3'}>
                                                                <span className="icon-bg"><img src={addCat}/></span>
                                                                <span className='step-circle'><img src={stepCircle} style={{width:'45px'}}/></span>
                                                            </div>
                                                            <div className={lang == 'ar' ? 'text-right mr-2' : 'mr-4'}>
                                                                <p className="small mb-0 text-uppercase font-InterMedium text-4f46e5"> {t('genDict.Step1')}</p>
                                                                <p className="mb-0 text-uppercase small font-InterMedium">{t('genDict.SelectCreateACategory')}</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li className="w-100 steps-li">
                                                        <div className="progress">
                                                            <div className="progress-bar w-100"></div>
                                                        </div>
                                                        <div className="d-flex align-items-center mt-2">
                                                            <div className={lang == 'ar' ? 'text-right' : 'mr-3'}>
                                                                <span className="icon-bg star"><img src={stars} style={{width:'29px'}}/></span>
                                                                <span className='step-circle'><img src={stepCircle} style={{width:'45px'}}/></span>
                                                            </div>
                                                            <div className={lang == 'ar' ? 'text-right mr-2' : 'mr-4'}>
                                                                <p className="small mb-0 text-uppercase font-InterMedium text-4f46e5">{t('genDict.Step2')}</p>
                                                                <p className="mb-0 text-uppercase small font-InterMedium">{t('genDict.Select_SelectLevel')}</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li className="w-100 steps-li">
                                                        <div className="progress">
                                                            <div className="progress-bar w-100"></div>
                                                        </div>
                                                        <div className="d-flex align-items-center mt-2">
                                                            <div className={lang == 'ar' ? 'text-right' : 'mr-3'}>
                                                                <span className="icon-bg video"><img src={video}/></span>
                                                                <span className='step-circle'><img src={stepCircle} style={{width:'45px'}}/></span>
                                                            </div>
                                                            <div className={lang == 'ar' ? 'text-right mr-2' : 'mr-4'}>
                                                                <p className="small mb-0 text-uppercase font-InterMedium text-4f46e5">{t('genDict.Step3')}</p>
                                                                <p className="mb-0 text-uppercase small font-InterMedium">{t('genDict.CreateCourse')}</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li className="w-100 steps-li">
                                                        <div className="progress">
                                                            <div className="progress-bar"></div>
                                                        </div>
                                                        <div className="d-flex align-items-center mt-2">
                                                            <div className={lang == 'ar' ? 'text-right' : 'mr-3'}>
                                                                <span className="icon-bg open-book"><img src={openBook}/></span>
                                                                <span className='step-circle'><img src={stepCircle} style={{width:'45px'}}/></span>
                                                            </div>
                                                            <div className={lang == 'ar' ? 'text-right mr-2' : 'mr-4'}>
                                                                <p className="small mb-0 text-uppercase font-InterMedium text-4f46e5">{t('genDict.Step4')}</p>
                                                                <p className="mb-0 text-uppercase font-InterMedium small font-InterMedium">{t('genDict.Add_Content')}</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    </ul>
                                                </div>
                                                <div className="form-fields pl-4 pr-6rem">
                                                    {console.log('catidsss',values.category_id)}
                                                    {console.log('levelidsss',values.level_id)
                                                    }
                                                <Form
                                                    size='large'
                                                    form={form}
                                                    initialValues={item}
                                                    fields={[]}
                                                    className="msform"
                                                    onFinish={(value) => {
                                                    if(Parameters.Mode === 'CLIENT'){
                                                        const user = JSON.parse(localStorage.getItem('auth-token') as string)?.user;
                                                        value.instructor_id = user.id;
                                                    }
                                                        if (!image.imageId) {
                                                            notification.error({ message: t('image.required') });
                                                            return;
                                                        }
                                                        const reqObj: any = value;
                                                        console.log('fillvalue',value)
                                                        reqObj['thumbnail_id'] = image.imageId;

                                                        if(draftCatVal !== null && draftCatVal !== ''){
                                                            reqObj['category_id'] = draftCatVal;
                                                            reqObj['draft_id'] = draftCourseId;
                                                        }
                                                        if(values.category_id !== ''){
                                                            reqObj['category_id'] = values.category_id;
                                                        }
                                                        if(item !== null){
                                                            reqObj['category_id'] = item.category_id;
                                                        }
                                                        if(item !== null){
                                                            reqObj['level_id'] = item.level_id;
                                                        }
                                                        if(draftLevelVal !== null && draftLevelVal !== ''){
                                                            reqObj['level_id'] = draftLevelVal;
                                                            reqObj['draft_id'] = draftCourseId;
                                                        }
                                                        if(values.level_id !== ''){
                                                            reqObj['level_id'] = values.level_id;
                                                        } 
                                                       
                                                        console.log('reqObj',reqObj)
                                                        // return
                                                        setSaving(true);
                                                        if (item && item.id) {
                                                            API_SERVICE.updateCourse(item.id, reqObj).then((d) => {
                                                                // history.goBack();
                                                                nextStep()
                                                            }).catch((e) => {
                                                                notification.error({ message: API_SERVICE.handleErrors(e) });
                                                                setSaving(false);
                                                            });
                                                        } else {
                                                            API_SERVICE.createCourse(reqObj).then((d) => {
                                                                // history.goBack();
                                                                const returnCourseData = JSON.parse(d.request.response)
                                                                idCourse(returnCourseData.data.id)
                                                                nextStep()
                                                            }).catch((e) => {
                                                                notification.error({ message: API_SERVICE.handleErrors(e) });
                                                                setSaving(false);
                                                            });
                                                        }
                                                    }}
                                                    layout='vertical'
                                                    requiredMark={true}
                                                >
                                                    {/* <Form
                                                        size='large' 
                                                        layout='vertical'
                                                        requiredMark={true}  
                                                        form={form} 
                                                        onFinish={submitFormData}
                                                    > */}
                                                        <fieldset>
                                                            {/* <div className="row"> */}
                                                            <div className={lang == 'ar' ? 'row text-right' : 'row'}>
                                                                <div className="col-md-5 mt-5">
                                                               
                                                                    <h5>{t('genDict.UploadCourseThumbnail')}</h5>
                                                                    <p className="text-secondary">{t('genDict.UploadCourseThumbnailParagraph')}</p>
                                                                </div>
                                                                <div className="col-md-7 mt-5">

                                                                    {
                                                                        uploading ? <Spin/> : (
                                                                            image.image ? <div>
                                                                                
                                                                                <div className="d-flex align-items-center">
                                                                              
                                                                                    <div className="uploadeImgBg mr-2">
                                                                                        <Image src={image.image} id="orgLogo" className="uploaded-img-cat" height={'48px'} width={'48px'}/>
                                                                                    </div>
                                                                                    <div>
                                                                                        {
                                                                                            RouteParams['mode'] !== 'view' && <Button className='btn btn-default' onClick={() => setImage({
                                                                                                image: null,
                                                                                                imageId: null,
                                                                                            })}>{t('genDict.remove')}</Button>
                                                                                            
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                                
                                                                            </div> : <Upload beforeUpload={(file) => {
                                                                                        if (!(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                                                                                            notification.error({ message: `PNG/JPG/JPEG ${t('genDict.required')}` });
                                                                                        }
                                                                                            uploadImage(file);
                                                                                            return file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg';
                                                                                        }}>
                                                                                        {/* <div className="d-flex align-items-center"> */}
                                                                                        <div className={lang === 'ar' ? 'd-flex align-items-center gap-2': 'd-flex align-items-center'}>
                                                                                            <div className="mr-2">
                                                                                                    <img src={imgIcon} className="logo-org"/>
                                                                                                {/* <i className="fa fa-picture-o logo-org"></i> */}
                                                                                                {/* <img src="#" id="orgLogo" className="uploaded-img-cat" height="48" width="48" style={{display:'none'}}/> */}
                                                                                            </div>
                                                                                            <div>
                                                                                                <Button className="btn btn-default">{t('genDict.uploadImage')}</Button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Upload>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                            <hr>
                                                            </hr> 
                                                            {/* <div className="row"> */}
                                                            <div className={lang == 'ar' ? 'row text-right' : 'row'}>
                                                                <div className="col-md-5 mt-4">
                                                                    <h5>{t('genDict.CourseInformation')}</h5>
                                                                    <p className="text-secondary">{t('genDict.CourseInformationParagraph')}</p>
                                                                </div>
                                                                <div className="col-md-7 mt-4">
                                                                    {/* <div className="form-group">
                                                                        <label className="text-secondary">Course Title</label>
                                                                        <input type="text" name="course-title" id="course-title" className="form-control"/>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label className="text-secondary">Short Description</label>
                                                                        <textarea className="form-control" name="short-desc" id="short-desc" rows={5}></textarea>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label className="text-secondary">Benefits</label>
                                                                        <textarea className="form-control" name="benefits" id="benefits" rows={5}></textarea>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label className="text-secondary">Description</label>
                                                                        <textarea className="form-control" name="desc" id="desc" rows={5}></textarea>
                                                                    </div> */}
                                                                    <Form.Item
                                                                        label={t('title.label')}
                                                                        name={['title', selectedLang]}
                                                                        rules={[
                                                                            { required: true, message: t('title.required') },
                                                                        ]}
                                                                    >
                                                                        {/* <Input disabled={!RouteParams['mode']} /> */}
                                                                        <Input disabled={RouteParams['mode'] === 'view'} />
                                                                    </Form.Item>
                                                                    {/* <Form.Item
                                                                        label={t('course.title.label')}
                                                                        name={['title', 'en']}
                                                                        rules={[
                                                                            { required: true, message: t('course.title.required') },
                                                                        ]}>
                                                                        <Input disabled={RouteParams['mode'] === 'view'} />
                                                                    </Form.Item> */}
                                                                    <Form.Item
                                                                        // initialValue={item ? item.short_description.de : ''}
                                                                        label={t('shortDescription.label')}
                                                                        name={['short_description', selectedLang]}
                                                                        rules={[
                                                                            { required: true, message: t('shortDescription.required') },
                                                                        ]}
                                                                    >
                                                                        {RouteParams['mode'] === 'view' ?
                                                                            <Input disabled />
                                                                            : <TextArea cols={4} />
                                                                        }
                                                                    </Form.Item>
                                                                    {/* <Form.Item
                                                                        initialValue={item ? item.short_description.en : ''}
                                                                        label={t('course.shortDescription.label')}
                                                                        name={['short_description', 'en']}
                                                                        rules={[
                                                                        ]}>
                                                                        {RouteParams['mode'] === 'view' ?
                                                                            <Input disabled />
                                                                            : <TextArea cols={4} />
                                                                        }
                                                                    </Form.Item> */}
                                                                    <Form.Item
                                                                        // initialValue={item ? item.benefits.de : ''}
                                                                        label={t('benefits.label')}
                                                                        name={['benefits', selectedLang]}
                                                                        rules={[
                                                                            { required: true, message: t('benefits.required') },
                                                                        ]}
                                                                    >
                                                                        {RouteParams['mode'] === 'view' ?
                                                                            <Input disabled />
                                                                            : <TextArea cols={4} />
                                                                        }
                                                                    </Form.Item>
                                                                    {/* <Form.Item
                                                                        initialValue={item ? item.benefits.en : ''}
                                                                        label={t('course.benefits.label')}
                                                                        name={['benefits', 'en']}
                                                                        rules={[]}>
                                                                        {RouteParams['mode'] === 'view' ?
                                                                            <Input disabled />
                                                                            : <TextArea cols={4} />
                                                                        }
                                                                    </Form.Item> */}
                                                                    <Form.Item
                                                                        // initialValue={item ? item.description.de : ''}
                                                                        label={t('description.label')}
                                                                        name={['description', selectedLang]}
                                                                        rules={[
                                                                            { required: true, message: t('description.required') },
                                                                            { min: 20, message: t('minLength20.required') },
                                                                        ]}
                                                                    >
                                                                        {RouteParams['mode'] === 'view' ?
                                                                            <Input disabled />
                                                                            : <TextArea cols={4} />
                                                                        }
                                                                    </Form.Item>
                                                                    {/* <Form.Item
                                                                        initialValue={item ? item.description.en : ''}
                                                                        label={t('course.description.label')}
                                                                        name={['description', 'en']}
                                                                        rules={[
                                                                            { required: true, message: t('course.descriptionDe.required') },
                                                                            { min: 20, message: t('course.description.minLength20') },

                                                                        ]}>
                                                                        {RouteParams['mode'] === 'view' ?
                                                                            <Input disabled />
                                                                            : <TextArea cols={4} />
                                                                        }
                                                                    </Form.Item> */}
                                                                </div>
                                                            </div>
                                                            <hr>
                                                            </hr>
                                                            {Parameters.Mode !== 'CLIENT' && <div className={lang == 'ar' ? 'row text-right' : 'row'}>
                                                            {/* {Parameters.Mode !== 'CLIENT' && <div className="row"> */}
                                                                <div className="col-md-5 mt-4">
                                                                    <h5>{t('genDict.CourseInstructor')}</h5>
                                                                    <p className="text-secondary">{t('genDict.CourseInformationParagraph')}</p>
                                                                </div>
                                                                <div className="col-md-7 mt-4">
                                                                    <Form.Item
                                                                        label={t('course.instructor.label')}
                                                                        name={'instructor_id'}
                                                                        rules={[
                                                                            {required: true, message: t('course.instructor.required')},
                                                                        ]}>
                                                                        <Select>
                                                                            {
                                                                            instructors.map((instructor: any) => {
                                                                            return <Option value={instructor.id}>{instructor.name}</Option>;
                                                                            })
                                                                            }
                                                                        </Select>
                                                                    </Form.Item>
                                                                </div>
                                                            </div>
                                                            }
                                                            <hr>
                                                            </hr>
                                                            {/* <div className="row"> */}
                                                            <div className={lang == 'ar' ? 'row text-right' : 'row'}>
                                                                <div className="col-md-5 mt-4">
                                                                    <h5>{t('genDict.Classification')}</h5>
                                                                    <p className="text-secondary">{t('genDict.CourseInformationParagraph')}</p>
                                                                </div>
                                                                <div className="col-md-7 mt-4">
                                                                <Form.Item
                                                                    label={t('course.isFeatured.label')}
                                                                    name='is_featured'
                                                                    valuePropName={'defaultChecked={true}'}
                                                                    rules={[]}
                                                                >
                                                                    <Switch defaultChecked={item ? item.is_featured === 0 ? false : true:false} />
                                                                </Form.Item>
                                                                <Form.Item
                                                                    label={t('course.isPopular.label')}
                                                                    name='is_popular'
                                                                    valuePropName={'defaultchecked={true} value={"abc"}'}
                                                                    rules={[]}
                                                                >
                                                                    <Switch defaultChecked={item ? item.is_popular === 0 ? false : true:false} />
                                                                </Form.Item>
                                                                </div>
                                                            </div>
                                                            <hr>
                                                            </hr>
                                                            {/* <div className="row"> */}
                                                            <div className={lang == 'ar' ? 'row text-right' : 'row'}>
                                                                <div className="col-md-5 mt-4">
                                                                    <h5>{t('genDict.CoursePlane')}</h5>
                                                                    <p className="text-secondary">{t('genDict.CourseInformationParagraph')}</p>
                                                                </div>
                                                                <div className="col-md-7 mt-4">
                                                                <Form.Item
                                                                    label={t('course.plan.label')}
                                                                    name={'plan'}
                                                                    rules={[
                                                                        { required: true, message: t('course.plan.required') },
                                                                    ]}>
                                                                    <Select onChange={(e)=>setPlan(e)}>
                                                                        {
                                                                            ['free', 'paid'].map((p) => {
                                                                                return <Option value={p}>{t('genDict.' + p)}</Option>;
                                                                            })
                                                                        }
                                                                    </Select>
                                                                </Form.Item>
                                                                {
                                                                    form.getFieldsValue()['plan'] === 'paid' && <>
                                                                        <Form.Item
                                                                            label={t('course.price.label')}
                                                                            name={'price'}
                                                                            rules={[
                                                                                {
                                                                                    required: true, message: t('course.price.required'),
                                                                                },
                                                                            ]}>
                                                                            <InputNumber min={0.01} disabled={!RouteParams['mode']} />
                                                                        </Form.Item>
                                                                        <Form.Item
                                                                            label={t('course.salePrice.label')}
                                                                            name={'sale_price'}
                                                                            rules={[
                                                                                ({ getFieldValue }) => ({
                                                                                    validator(_, value) {
                                                                                        if (!value) {
                                                                                            return Promise.reject(
                                                                                                t('course.salePrice.required'),
                                                                                            );
                                                                                        }
                                                                                        if (value <= getFieldValue('price')) {
                                                                                            return Promise.resolve();
                                                                                        }
                                                                                        return Promise.reject(
                                                                                            t('course.salePrice.lessThanPrice'),
                                                                                        );
                                                                                    },
                                                                                }),
                                                                            ]}>
                                                                            <InputNumber min={0.01} disabled={!RouteParams['mode']} />
                                                                        </Form.Item>
                                                                    </>
                                                                }
                                                                </div>
                                                            </div>
                                                            <hr>
                                                            </hr>
                                                            {
                                                                <Form.Item className='float-right' style={{width:'max-content'}}>
                                                                    <Button
                                                                        htmlType="submit"
                                                                        shape="round"
                                                                        loading={saving || uploading}
                                                                        size={'large'}
                                                                        className='btn btn-blue'
                                                                    >
                                                                       {t('genDict.saveAndContinue')}
                                                                    </Button>
                                                                </Form.Item>
                                                            }
                                                            {
                                                                <Form.Item className='float-right mr-3' style={{width:'max-content'}}>
                                                                    <Button
                                                                        // htmlType="submit"
                                                                        shape="round"
                                                                        size={'large'}
                                                                        className='btn btn-default'
                                                                        loading = {draftSaving}
                                                                        disabled = {item ? true : false}
                                                                        onClick={saveDraftData}
                                                                    >
                                                                        {t('genDict.SaveAsDraft')}
                                                                    </Button>
                                                                </Form.Item>
                                                            }
                                                            </fieldset>
                                                    </Form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    
                </div>
            
            </>
        )
}
export default CourseDetails 